import { useQuery } from "@tanstack/react-query";
import { creditApi } from "@/lib/credit.api";
import { queryKeys } from "@/lib/query-keys";
import { isValidRecordId } from "@/lib/route-id";

export function usePartyCreditBalance(partyId: number) {
  return useQuery({
    queryKey: queryKeys.credits(partyId),
    enabled: isValidRecordId(partyId),
    queryFn: () => creditApi.getBalance(partyId).then((r) => r.data),
  });
}
